import './track-statistics.sass';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import Menu from 'controls/menu/Menu';
import Toolbar from 'components/track-statistics/toolbar/Toolbar';
import TrackFilter from 'components/track-statistics/track-filter/TrackFilter';
import ParamsFilter from 'components/track-statistics/params-filter/ParamsFilter';
import Values from 'components/track-statistics/values/Values';

export default class TrackStatistics extends Component {
  render() {
    return (
      <div>
        <Menu />
        <div className='track-statistics container-fluid'>
          <div className='row'>
            <div className='col-sm-12'>
              <Toolbar/>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-3'>
              <TrackFilter/>
            </div>
            <div className='col-sm-3'>
              <ParamsFilter/>
            </div>
            <div className='col-sm-6'>
              <Values/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
